import { render, staticRenderFns } from "./LayoutFiles.vue?vue&type=template&id=6fa90098&scoped=true"
import script from "./LayoutFiles.vue?vue&type=script&lang=js"
export * from "./LayoutFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa90098",
  null
  
)

export default component.exports